<template>
  <div id="Sealdetail">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <!-- <h3>用章审核</h3> -->
    <div class="contain">
      <el-row>
        <el-col :span="14">
          <el-form :model="form" label-width="128px">
            <el-form-item label="申请人" prop="applicantName">
              <el-input
                v-model="form.applicantName"
                class="input"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="申请时间" prop="postTime">
              <el-date-picker
                disabled
                class="input"
                v-model="form.postTime"
                type="datetime"
                placeholder="请选择申请时间"
              >
              </el-date-picker>
              <!-- <el-input prop="form.postTime" class="input" readonly></el-input> -->
            </el-form-item>
            <el-form-item
              label="用章类型"
              prop="sealType"
              v-if="form.newsType == null"
            >
              <el-select
                v-model="form.sealType"
                placeholder="请选择"
                class="input"
                disabled
              >
                <el-option
                  v-for="item in seal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="二次审批人" prop="approver">
              <el-input v-model="form.approver" class="input" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="用章事由" prop="reason">
              <!-- <el-input :value="form.cuase" class="input" placeholder="请输入"></el-input> -->
              <el-input
                class="input"
                v-model="form.reason"
                :autosize="{ minRows: 3 }"
                type="textarea"
                disabled
              />
            </el-form-item>
            <!-- <el-form-item label="支持导出的材料：" v-if="form.newsType"> -->
            <el-form-item label="支持导出的材料：" v-if="false">
              <div style="display: flex">
                <!-- <el-checkbox-group v-model="checkedCities">
                  <el-checkbox
                    style="display: block; padding-top: 20px"
                    v-for="city in cities"
                    :label="city.name"
                    :key="city.name"
                    disabled
                  >
                    <div style="display: flex; align-items: flex-start">
                      <div style="width: 180px">{{ city.name }}</div>
                      <div>
                        <el-select
                          size="mini"
                          v-model="city.stype"
                          placeholder="请选择用章类型"
                          disabled
                          value-key="value"
                          multiple
                        >
                          <el-option
                            v-for="item in seal"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </el-checkbox>
                </el-checkbox-group> -->
                <div>
                  <el-checkbox-group v-model="checkedCities">
                    <el-checkbox
                      style="display: block; padding-top: 20px"
                      v-for="city in cities"
                      :label="city.name"
                      :key="city.name"
                      disabled
                      >{{ city.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
                <div>
                  <div
                    style="margin-left: 15%; padding-top: 12px"
                    v-for="city in cities"
                  >
                    <el-select
                      size="mini"
                      v-model="city.stype"
                      placeholder="请选择用章类型"
                      class="yz_input"
                      clearable
                      filterable
                      multiple
                      disabled
                    >
                      <el-option
                        v-for="item in seal"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="附件" prop="file" v-if="form.file.length > 0">
              <div v-for="item in form.file" :key="item.fid" class="input">
                <div class="fj">
                  <div style="flex: 1">
                    <img
                      src="../../assets/file/word.svg"
                      v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                    />
                    <img
                      src="../../assets/file/xls.svg"
                      v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                    />
                    <img
                      src="../../assets/file/png.svg"
                      v-if="
                        item.ftype == 'jpg' ||
                        item.ftype == 'jpeg' ||
                        item.ftype == 'png'
                      "
                    />
                    <img
                      src="../../assets/file/PDF.svg"
                      v-if="item.ftype == 'pdf'"
                    />
                  </div>
                  <div class="fname" style="flex: 9">
                    <div style="word-break: break-all">
                      {{ getFileName(item.name) }}
                    </div>
                    <div class="word">
                      <span
                        @click="look(item)"
                        class="look"
                        v-if="
                          $store.state.rolesname.includes(
                            'SealApprovedetail_look'
                          )
                        "
                        >预览</span
                      >
                      <span
                        class="down"
                        @click="down(item)"
                        v-if="
                          $store.state.rolesname.includes(
                            'SealApprovedetail_down'
                          )
                        "
                        >下载</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="关联案件" v-if="form.caseId">
              <el-button @click="detailLink" class="glbtn">
                {{ form.linkName }}</el-button
              >
            </el-form-item>
            <el-form-item label="关联投标" v-if="form.tenderId">
              <el-button @click="detailLink" class="glbtn">
                {{ form.linkName }}</el-button
              >
            </el-form-item>
            <el-form-item label="关联顾问" v-if="form.adviserId">
              <el-button @click="detailLink" class="glbtn">
                {{ form.linkName }}</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="10">
          <div class="right">
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in logs"
                :key="index"
                color="#3077E6"
                :timestamp="item.reason"
              >
                <div style="display: flex; justify-content: space-between">
                  <div>{{ item.content }}</div>
                  <div class="time">
                    {{ handleTime(item.timestamp) }}
                  </div>
                </div>
                <div style="color: #909399">{{ item.type }}</div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="right" v-if="processlogs.length > 0">
            <div style="margin-bottom: 10px; font-weight: 600">已审核流程</div>
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in processlogs"
                :key="index"
                color="#3077E6"
                :timestamp="item.reason"
              >
                <div style="display: flex; justify-content: space-between">
                  <div>{{ item.type }}</div>

                  <div class="time">
                    {{ item.timestamp }}
                  </div>
                </div>
                <div style="color: #909399">{{ item.name }} {{ item.con }}</div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="right" v-if="Process.length > 0">
            <div style="margin-bottom: 10px; font-weight: 600">未审核</div>
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in Process"
                :key="index"
                :timestamp="item.type"
              >
                {{ item.name }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-col>
      </el-row>
      <div class="footer">
        <el-button
          type="primary"
          @click="approval(0)"
          v-if="
            $store.state.rolesname.includes('SealApprove_pass') && dayin == 0
          "
          >通过</el-button
        >
        <el-button
          type="warning"
          @click="approval(1)"
          v-if="
            $store.state.rolesname.includes('SealApprove_refuse') && dayin == 0
          "
          >驳回</el-button
        >
        <el-button class="history" @click="history">返回</el-button>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="approvaldialog"
      width="30%"
      center
      :show-close="false"
      @close="handleCancle"
    >
      <div class="fail" v-if="title">
        <el-form
          :model="failform"
          label-width="80px"
          ref="failformref"
          :rules="failformrules"
        >
          <el-form-item prop="Reason" label="驳回原因">
            <el-input
              v-model="failform.Reason"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div class="refuse">
          <el-button @click="refuse('failformref')" type="primary"
            >驳回</el-button
          >
        </div>
      </div>
      <div class="success" v-else>
        <div><img src="../../assets/success.svg" /></div>
        <div class="pass">已通过</div>
      </div>
    </el-dialog>
    <!-- 预览dialog -->
    <el-dialog
      center
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
      
<script>
import { SealDetail, SealSuccess, SealReject } from '../../api/examine'
import { requestDownLoadFile, requestReview } from '../../api/counsel.js'
import { requestDownLoadFile as downfile } from '../../api/seal'
import { CaseLog, CaseProcess, CaseApprover } from '../../api/bankrupt'
import mammoth from 'mammoth'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
var reason = (rule, value, callback) => {
  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (value.match(/^[ ]*$/)) {
      callback(new Error('驳回原因不能为空'))
    }
  }
  callback()
}
export default {
  name: 'Sealdetail',
  data() {
    return {
      isLoading: false,
      next: true, //是否是三级菜单,显示二级菜单
      Guid: '',
      dayin: 0,
      Isapproval: false,
      form: {
        file: []
      },
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ], //合同用章
      //审核弹出框
      approvaldialog: false,
      title: '',
      failform: {},
      failformrules: {
        Reason: [
          { required: true, message: '驳回原因不能为空', trigger: 'change' },
          { validator: reason, trigger: 'blur' }
        ]
      },
      logs: [],
      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1, //回退次数

      Process: {},
      processlogs: {},

      checkedCities: [],
      cities: null,
      sealbianji: true
    }
  },

  methods: {
    Successlog() {
      CaseApprover({ SealId: this.$route.query.guid }).then((res) => {
        if (res.data.status == 'success') {
          this.processlogs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    GetLog() {
      //获取日志
      CaseLog({ Id: this.Guid }).then((res) => {
        if (res.data.status == 'success') {
          this.logs = res.data.data
          if (this.logs.Reason) {
            this.logs.Reason = JSON.parse(this.logs.Reason).Reason
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    },
    history() {
      this.$router.go(-this.times)
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      //  console.log(jsonData)
      //  console.log(jsonData.status)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.isLoading = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          requestDownLoadFile({ Id: item.fid }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.fid }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.fid }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.isLoading = false
      } else {
        this.isLoading = false
        this.$message.error('不支持此文件预览')
      }
    },
    async down(item) {
      //下载
      this.isLoading = true
      const res = await downfile({
        Id: item.fid
      })
      if (res.status == '201') {
        this.$message.error('找不到文件')
        this.isLoading = false
        return
      }
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
        this.GetLog()
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      this.isLoading = false
      fileReader.readAsText(data)
    },

    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null
      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name)
        this.isLoading = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },
    getFileName(filename) {
      if (filename) {
        var fix = filename.substring(0, filename.lastIndexOf('.'))
        return fix
      }
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    GetData() {
      //获取详情数据
      this.isLoading = true
      SealDetail({ Id: this.Guid }).then((res) => {
        if (res.data.status == 'success') {
          this.form = res.data.data
          if (res.data.data.newsType != null) {
            var typeid = res.data.data.linktype.typeId
            // console.log(typeid)
            if (this.checkedCities.length > 0) {
              this.checkedCities = []
            }
            if (typeid == '00000000-0000-0000-0001-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '听证出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0001-0001-0002-000000000000') {
              this.cities = [
                {
                  name: '委托协议（辩护）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '为犯罪嫌疑人提供帮助的委托协议', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（侦查）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（检、审）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '会见专用介绍信（嫌疑人 被告人）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '取保候审申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '刑事案件代理委托协议（诉讼代理人）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（刑事附带民事）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（诉讼代表人）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '调查取证申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '延期审理申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '解除强制措施申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '提请收集、调取证据申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '通知证人出庭申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '申请取保候审保证书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师事务所函（侦查）', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师会见在押犯罪嫌疑人的函（侦查）', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师事务所函（检、审）', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0002-0002-0003-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '行政复议出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0003-0003-0004-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0004-0004-0005-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0005-0005-0006-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0006-0006-0007-000000000000') {
              this.cities = [
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0007-0007-0008-000000000000') {
              this.cities = [
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0008-0008-0009-000000000000') {
              this.cities = [
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)

                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0009-0009-0010-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0010-0010-0011-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0011-0011-0012-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0012-0012-0013-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            }
            var oldCities = res.data.data.newsType

            oldCities.forEach((val) => {
              this.checkedCities.push(val.name)
              this.cities.forEach((v) => {
                if (v.name == val.name) {
                  v.stype = val.stype
                }
              })
            })
            const cC = new Set(this.checkedCities.map((m) => m))

            var bbk = []

            if (res.data.data.result != 1 || res.data.data.result == null) {
              this.cities.forEach((city, index, array) => {
                // 不包含
                if (!cC.has(city.name)) {
                  bbk.push(city.name)
                }
              })
              this.cities = this.cities.filter(function (item) {
                return !bbk.includes(item.name)
              })
            } else {
              this.cities.forEach((city) => {
                // 不包含
                if (!cC.has(city.name)) {
                  city.stype = []
                }
              })
            }
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
        this.isLoading = false
      })
    },
    handleCancle() {
      if (this.Isapproval) {
        this.$router.go(-1)
        this.Isapproval = false
      }
    },
    approval(type) {
      //审核
      var header = document.getElementsByClassName('el-dialog__header')
      if (type == 0) {
        this.isLoading = true
        SealSuccess({ Id: this.Guid }).then((res) => {
          if (res.data.status == 'success') {
            this.title = ''
            header[0].style.display = 'none'
            this.approvaldialog = true
            this.Isapproval = true
            this.$message.success('审核成功')
            this.history()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
          this.isLoading = false
        })
      }
      if (type == 1) {
        this.title = '驳回原因'
        header[0].style.display = ''
        this.approvaldialog = true
        this.failform.id = this.Guid
      }
    },
    refuse(form) {
      //驳回
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          SealReject({
            Id: this.failform.id,
            Reason: this.failform.Reason
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('审核成功')
              this.approvaldialog = false
              this.Isapproval = true
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.approvaldialog = false
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
        } else {
          this.$message.error('有必填项为空！')
          return false
        }
      })
    },
    detailLink() {
      // console.log('form',this.form)
      //查看关联案件等
      if (this.form.linktype) {
        var caseType = this.form.linktype.typeId.substring(21, 23)
        if (caseType == 12 || caseType == 13) {
          if (
            this.$store.state.rolesname.includes('myDetail') ||
            this.$store.state.rolesname.includes('allDetail')
          ) {
            var type = '破产'
            if (caseType == 13) {
              var type = '破产投标'
            }
            this.$router.push({
              path: 'bankruptdetail',
              name: 'bankruptdetail',
              query: { guid: this.form.caseId, type: type, mystatus: 2 }
            })
          } else {
            this.$message.error('没有页面权限')
          }
        } else {
          if (
            this.$store.state.rolesname.includes('myDetail') ||
            this.$store.state.rolesname.includes('allDetail')
          ) {
            this.$store.commit('setmenustatus', 1)
            this.$router.push({
              path: '/home/case/caseinfo',
              query: {
                guid: this.form.caseId,
                status: this.form.linktype.typeId,
                caseType: caseType
              }
            })
          } else {
            this.$message.error('没有页面权限')
          }
        }
      } else {
        if (this.form.linkName == '投标申请') {
          if (this.$store.state.rolesname.includes('Biddetail')) {
            this.$router.push({
              path: '/home/seal/Biddetail',
              query: {
                guid: this.form.tenderId
              }
            })
          } else {
            this.$message.error('没有页面权限')
          }
        }
        if (this.form.linkName == '顾问申请') {
          if (this.$store.state.rolesname.includes('allCounsel')) {
            // this.$router.push({
            //   path: '/home/counsel/allCounsel'
            //   // query: {
            //   //   guid: this.form.tenderId,
            //   // }
            // })
            var url =
              '/#/home/counsel/allCounsel?companyName=' +
              this.form.companyName +
              '&&id=' +
              this.form.adviserId
            let mywin = window.open(url, 'allCounsel')
            mywin.onload = function () {
              mywin.location.reload()
            }
          } else {
            this.$message.error('没有页面权限')
          }
        }
      }
    },
    GetProcess() {
      CaseProcess({ SealId: this.Guid }).then((res) => {
        if (res.data.status == 'success') {
          this.Process = res.data.data
        } else if (
          res.status == '401' ||
          res.status == '402' ||
          res.status == '403'
        ) {
          this.$message.error(res.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    }
  },
  created() {
    this.Guid = this.$route.query.guid
    this.dayin = this.$route.query.dayin
    if (this.dayin != 1) {
      this.dayin = 0
    }
    this.getvalue()
    this.GetData()
    this.GetLog()
    this.GetProcess()
    this.Successlog()
  },
  computed: {}
}
</script>
      
<style lang="less" scoped>
#Sealdetail .contain {
  width: 90%;
  margin: auto;
}
.right {
  width: 80%;
  margin: auto;
  margin-top: 3.125rem;
}
#Sealdetail .input {
  width: 50%;
}

#Sealdetail .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#Sealdetail .fjimg {
  width: 16%;
  margin-bottom: 10px;
}

#Sealdetail .input img {
  width: 100%;
  height: 100%;
}

#Sealdetail .fname {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}

#Sealdetail /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#Sealdetail .look {
  color: #fe964a;
  margin-right: 10px;
}

#Sealdetail .down {
  color: #2bc887;
}

#Sealdetail .word {
  line-height: 18px;
  cursor: default;
}

// 底部按钮
#Sealdetail .footer {
  width: 100%;
  margin: auto;
  text-align: center;
}

#Sealdetail .history {
  border: 1px solid rgba(43, 200, 135, 1);
  color: rgba(43, 200, 135, 1);
}

#Sealdetail .btnfail {
  border: 1px solid #3077e6;
  color: #3077e6;
}

// 弹出框
#Sealdetail /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

#Sealdetail .success {
  width: 100%;
  text-align: center;
  display: inline-flex;
  flex-direction: column;
}

#Sealdetail .pass {
  color: #718096;
  font-size: 24px;
  margin-top: 12px;
}

#Sealdetail .fail {
  width: 100%;
}

#Sealdetail .refuse {
  width: 100%;
  text-align: center;
}
.glbtn {
  border: none;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  padding: 13px 0px;
}
</style>
      